(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/forecast-payment.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/forecast-payment.js');
'use strict';

svs.game_results.models.ForecastPayment = Backbone.Model.extend({
  initialize() {
    const forecast = this.get('forecast');
    const roundIsLive = forecast && forecast.drawState >= svs.game_results.constants.drawStates.CLOSED && forecast.drawState < svs.game_results.constants.drawStates.FINALIZED;
    this.set('roundIsLive', roundIsLive);
    this.set('winresult', forecast.winresult);
    this.listenTo(this, 'change:winresult', this.winresultUpdated);
    this.setWinAmounts();
  },
  winresultUpdated() {
    this.setWinAmounts();
    this.trigger('winresultUpdate', this);
  },
  setWinAmounts() {
    const rowPrice = parseInt(this.get('rowPrice'), 10);
    const forecast = this.get('forecast');
    forecast.winresult.forEach(currentForecast => {
      let winAmount = parseFloat(svs.utils.format.CurrencyFromJupiterString(currentForecast.winValue));
      if (rowPrice) {
        winAmount *= rowPrice;
      }
      currentForecast.winAmount = Math.floor(winAmount);
    });
    if (forecast.multiForecast) {
      forecast.multiForecast.forEach(currentForecast => {
        let winAmount = parseFloat(svs.utils.format.CurrencyFromJupiterString(currentForecast.winValue));
        if (rowPrice) {
          winAmount *= rowPrice;
        }
        currentForecast.winAmount = Math.floor(winAmount);
      });
      const multiForecast = {
        winDivs: []
      };
      const maxWinDiv = _.max(forecast.multiForecast, item => item.winDiv).winDiv;

      multiForecast.possibleOutcomes = _.uniq(_.pluck(forecast.multiForecast, 'outcome'));
      for (let i = 1; i <= maxWinDiv; i++) {
        multiForecast.winDivs.push({
          winDiv: i,
          forecasts: _.where(forecast.multiForecast, {
            winDiv: i
          })
        });
      }
      if (multiForecast.winDivs.length === 1) {
        const eventNum = multiForecast.winDivs[0].forecasts[1].eventNumber;
        const event = _.find(forecast.drawResults, item => item.eventNumber === eventNum);
        if (event && this.has2Outcomes(event.eventTypeId)) {
          multiForecast.winDivs[0].forecasts[1].hidden = true;
        }
      }
      this.set('multiForecast', multiForecast);
    }
  },
  has2Outcomes(eventTypeId) {
    return eventTypeId === svs.game_results.constants.challengeEventTypeIds.EVENT_OVER_UNDER || eventTypeId === svs.game_results.constants.challengeEventTypeIds.EVENT_TOTALT_ANTAL_MAL || eventTypeId === svs.game_results.constants.challengeEventTypeIds.EVENT_12;
  }
});

 })(window);